<template>
  <label class="bx-checkbox">
    <input
      :disabled="disabled"
      type="checkbox"
      :checked="value"
      @input="onInput"
      ref="input"
    />
    <div class="check"></div>
    <span class="bx-label">
      <slot></slot>
    </span>
  </label>
</template>
<script>
export default {
  name: "bx-checkbox",
  props: {
    value: {
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onInput() {
      this.$emit("input", this.$refs.input.checked);
    }
  }
};
</script>
